import gql from "graphql-tag";
import get from "lodash/get";

export const USER_UPDATE_PHONE_MUTATION = gql` 
	mutation UserUpdatePhone($input: UserUpdatePhoneNumberInput!) {
		userUpdatePhoneNumber(input: $input) {
			success
			statusCode
		}
	}
`;

export const UPDATE_PHONE_STATUS_CODES = {
	"UNKOWN": 0,
	"SUCCESS": 1,
	"PHONE_TAKEN": 2,
	"INVALID_TSP": 3,
	"UPDATE_FAILED": 5,
	"INVALID_USERID": 6,
	"BLACKLISTED": 7,
};

export const getUserUpdatePhoneSuccess = (data) => get(data, "data.userUpdatePhoneNumber.success");

export const getUserUpdatePhoneStatusCode = (data) => get(data, "data.userUpdatePhoneNumber.statusCode");



// WEBPACK FOOTER //
// ./src/shared/mutations/sms.js